import { useLocation, useParams } from 'react-router-dom'
import { Header } from '~components/web-components/top-bar'
import { useGetMe } from './queries/me/use-get-me'
import { GetPoolsResItem, useGetPools } from './queries/pools/use-get-pools'
import { sortItems } from './use-pool-select-options'

/** Pools that should not be displayed in the pool selector */
export const POOL_SELECTOR_BLOCKLIST = ['VLAC']

export function usePoolSubPages() {
  const params = useParams()
  const { pathname } = useLocation()
  const { data: me } = useGetMe()
  const { data: enabledPools } = useGetPools()

  const topBarHeaders: Header[] = []

  if (me && enabledPools) {
    const allPools = filterEnabledPools(me.profitCenterPools, enabledPools)
    const poolsWithActiveVessels = filterEnabledPools(
      me.activePools,
      enabledPools,
    )

    const poolsWithInactiveVessels = allPools.filter(
      (pool) => !poolsWithActiveVessels.includes(pool),
    )

    poolsWithActiveVessels?.forEach((poolName) => {
      topBarHeaders.push({
        title: poolName?.toUpperCase(),
        link: constructTopBarHeaderLink({ poolName, pathname, params }),
      })
    })

    poolsWithInactiveVessels?.forEach((poolName) => {
      topBarHeaders.push({
        title: poolName?.toUpperCase(),
        link: constructTopBarHeaderLink({ poolName, pathname, params }),
        variant: 'secondary',
      })
    })

    sortItems(topBarHeaders, (header) => header.title)
  }

  const alphabeticalSortedTopBarHeaders = topBarHeaders.sort((a, b) => {
    if (a.title < b.title) return -1
    if (a.title > b.title) return 1
    return 0
  })

  return alphabeticalSortedTopBarHeaders
}

function constructTopBarHeaderLink({
  poolName,
  pathname,
  params,
}: {
  poolName: string
  pathname: string
  params: any
}) {
  const poolNameLC = poolName.toLocaleLowerCase()
  const sanitizedPathname = pathname.replace(/%20/g, ' ').toLowerCase()

  const newPath = params.pool
    ? sanitizedPathname.replace(params.pool, poolNameLC)
    : `${sanitizedPathname}/${poolNameLC}`

  return newPath.substring(1) // removing "/" at the beginning
}

function filterEnabledPools(
  pools?: string[],
  enabledPools?: GetPoolsResItem[],
) {
  if (!pools || !enabledPools) return []
  return pools.filter(
    (pool) =>
      enabledPools.some((item) => item.name === pool) &&
      !POOL_SELECTOR_BLOCKLIST.includes(pool),
  )
}
